import React, { useState,useEffect,useRef } from "react";
import { Link,useNavigate,useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";

import { isNull,isObjEmpty,escapeHtml, unescapeHtml,SetEmptyInputFile,DownloadFile } from "../../components/common/Common";
import cancelIcon from "../../img/icon/icon-cancel.svg";
import "../../css/style.css";

//공지사항 편집/등록/보기
const NoticeDetail = () => {
  let { board_idx } = useParams();
  const fileRef= useRef(null);

  const branch_idx = Number(localStorage.getItem('branch_idx'));

  const navigate = useNavigate();
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varModeNotice,setModeNotice] = useState("")
  const [varNoticeInfo,setNoticeInfo] = useState({});

  //답변유무
  const [varSendPush,setSendPush] = useState(false);

  const GetNoticeInformation = async() => {
    const sendData = {board_idx:board_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_notice_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const dataInfo = datas.notices[0];
        setNoticeInfo(dataInfo); 
        if(dataInfo.board_bh_idx > 0) setModeNotice('disable-only');
        else setModeNotice('read-only');
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});

    //작업모드 
    if(Number(board_idx) > 0){
      GetNoticeInformation();
    } else {
      //공지사항등록
      setSendPush(true);
      //등록모드
      const newData = {board_idx:0,board_bh_idx:branch_idx,mem_idx:branch_idx,board_top:0,board_title:"",board_comment:"",board_attach:0,board_file:null,board_real_file:null,board_rdate:null,board_status:1};
      setNoticeInfo(newData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //정보입력부
  const onChangeInputHandler = (e) => {
    const { name, value } = e.currentTarget;
    if(name === "board_title" || name === "board_comment") {  //마마몽떼/플라이
      setNoticeInfo({...varNoticeInfo,[name]:escapeHtml(value)});
      if(name === "board_comment" && !varSendPush) setSendPush(true);
    } else if(name === "board_top") {
      const ichecked = Number(e.currentTarget.checked);
      setNoticeInfo({...varNoticeInfo,[name]:ichecked});
    } else {
      setNoticeInfo({...varNoticeInfo,[name]:value});
    }
  }

  //수정모드로 변경
  const onEditNoticeHandler = (e) => {
    const diableBoxes = document.querySelectorAll(".disable-only");
    const showBoxes = document.querySelectorAll(".show-only");
    const hideBox = document.querySelector('.hide-only');
    const buttonNumBox = document.querySelector('.btn-no');
    for(var i1=0; i1 < diableBoxes.length; i1++) {
      diableBoxes[i1].classList.remove('disable-only');
    }
    for(var i2=0; i2 < showBoxes.length; i2++) {
      showBoxes[i2].classList.add('hide-only');
    }
    hideBox.classList.remove('hide-only');
    buttonNumBox.setAttribute('style','width:48%');
  }

  //삭제
  const onDeleteNoticeHandler = async(e) => {
    const sendData = {board_idx:board_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_delete_notices`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        navigate('/Branch/NoticeSet');
      } else {
        alert(datas.message);
      }
    });
  }

  //등록-------------------------------------------------------------------------------------
  const onUpdateNoticeHandler = async(e) => {
    if(isNull(varNoticeInfo.board_title)) {
      alert('제목을 먼저 입력하세요.'); return false;
    } else if(varNoticeInfo.board_comment === 0) {
      alert('공지내용을 먼저 입력하세요.'); return false;
    }

    if(!window.confirm('공지사항을 등록하시겠습니까?')) return false;

    if(varNoticeInfo.board_attach===1 && !isNull(fileRef.current.files[0])) {
      console.log(fileRef.current.files[0].name);
      let formData = new FormData();
      formData.append('notices',fileRef.current.files[0]);
      await axios.post(`${process.env.REACT_APP_HOST}/notices`,formData).then((res) => {
        const datas = res.data;
        console.log(datas);
        if(datas.retvalue === 1) {
          const fileName = datas.fileName;
          UpdateNoticeInformation(fileName);
        } else {
          alert(datas.message);
        }
      });
    } else {
      UpdateNoticeInformation("");
    }
  }

  //공지사항 정보 저장
  const UpdateNoticeInformation = async(fileName) => {
    const sendData = {board_idx:board_idx,dataInfo:varNoticeInfo,fileName:fileName};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_notices`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const newIndex = datas.board_idx;
        if(varSendPush) SendPushMessage(newIndex);
        else navigate('/Branch/NoticeSet');
      } else {
        alert(datas.message);
      }
    });
  }

  //푸시보내기
  const SendPushMessage = async (newIndex) => {
    if(!window.confirm("푸시메시지를 발송하시겠습니까?")){
      navigate('/Branch/NoticeSet');
      return false;
    } 
    const pushTitle = "[마마몽떼] 새로운 공지사항이 등록되었습니다.";
    const pushMessage = varNoticeInfo.board_title;
    const pushUrl = `${process.env.REACT_APP_WEB_URL}/Parents/NoticeView/${newIndex}`;
    const sendData = {bh_idx:branch_idx,pushTitle:pushTitle,pushMessage:pushMessage,pushUrl:pushUrl};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_push_multi_message`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
      if(datas.retvalue === 1) {
        navigate('/Branch/NoticeSet');
      }
    });
  }
  //첨부파일------------------------------------------------------------------------------------------------
  //파일첨부
  const onAddAttachFileHandler = (e) => {
    e.preventDefault();
    fileRef.current.click();
  }
  //사진 선택후 화면에서 표시
  const onChangeAttachFileHandler = (e) => {
    const uploadFile = fileRef.current.files[0];
    console.log(uploadFile);
    //변수값 재조정
    setNoticeInfo({...varNoticeInfo, board_attach:1,board_real_file:uploadFile.name});
  }
  //사진삭제
  const onDeleteAttachFileHandler = async(e) => {
    if(isNull(varNoticeInfo.board_file)) {
      const fileBox = fileRef.current;
      SetEmptyInputFile(fileBox);
      setNoticeInfo({...varNoticeInfo, board_attach:0,board_real_file:null});
    } else {
      const sendData = {board_idx:board_idx};
      console.log(sendData);
      await axios.post(`${process.env.REACT_APP_HOST}/branch_delete_notices_attachfile`,sendData).then((res) => {
        const datas = res.data;
        console.log(datas);
        if(datas.retvalue === 1) {
          setNoticeInfo({...varNoticeInfo, board_attach:0,board_file:null,board_real_file:null});
        } else {
          alert(datas.message);
        }
      });
    }
  }

  //첨부파일 다운로드
  const onDownloadAttachFileHandler = async(e) => {
    const downfile = `${process.env.REACT_APP_HOST}/notices/${varNoticeInfo.board_file}`;
    DownloadFile(downfile,varNoticeInfo.board_real_file,1);
  }

  return isObjEmpty(varNoticeInfo)?null:(
    <div className="vh-content">
      <HeaderBranchTitle varPageTitle={Number(board_idx)===0?'공지사항 등록':'공지사항 상세'} varBackString={'/Branch/NoticeSet'}/>
      <div className="vh-content-body">
        <div className="center-wrap">
					<div className="oper-notice-wrap">
            <div className="form-group mb15">
              <div className="line">
                <label className="form-label">제목</label>
                {Number(board_idx)>0 && varNoticeInfo.board_bh_idx!==branch_idx?null:
                  <div className="btn-fix">
                    <input type="checkbox" name="board_top" id="fixNotice" checked={varNoticeInfo.board_top} className={`${varModeNotice}`} onChange={e=>onChangeInputHandler(e)}/>
                    <label  className={`fix-label ${varModeNotice}`} htmlFor="fixNotice">상단고정</label>
                  </div>
                }
              </div>
              <div className="field-group">
                <input type="text" name="board_title" placeholder="제목을 입력하세요." value={unescapeHtml(varNoticeInfo.board_title)} className={`form-control ${varModeNotice}`} onChange={e=>onChangeInputHandler(e)}/>
              </div>
            </div>
            <div className="form-group mb15">
              <label className="form-label">내용</label>
              <div className="field-group">
                <textarea className={`${varModeNotice}`} name="board_comment" value={unescapeHtml(varNoticeInfo.board_comment)} onChange={e=>onChangeInputHandler(e)}/>
              </div>
            </div>
            {/* 관리자가 올린 공지사항 */}
            {Number(board_idx)>0 && varNoticeInfo.board_bh_idx===0?
              varNoticeInfo.board_attach===0?null:
              <div className="form-group mb15">
                <div className={`file-box`}>
                  <p onClick={e=>onDownloadAttachFileHandler(e)}>{varNoticeInfo.board_real_file}</p>
                  {/* <button className="btn-cancel" style={{border:"none"}} onClick={e=>onDeleteAttachFileHandler(e)}><img src={cancelIcon} alt="" /></button> */}
                </div>
              </div>
            :
              <div className="form-group mb15">
                <p className="form-label">첨부파일</p>
                {/* <label className={`${varModeNotice}`} htmlFor="file">
                  <div className={`btn-upload ${varModeNotice}`} onClick={e=>onAddAttachFileHandler(e)}>첨부 파일 선택하기</div>
                </label> */}
                <div className={`btn-upload ${varModeNotice}`} onClick={e=>onAddAttachFileHandler(e)}>첨부 파일 선택하기</div>
                <input type="file" accept="image/*" ref={fileRef} id="file" onChange={e=>onChangeAttachFileHandler(e)}/>
                {varNoticeInfo.board_attach === 0?null:
                  <div className={`file-box ${varModeNotice}`}>
                    <p onClick={e=>onDownloadAttachFileHandler(e)}>{varNoticeInfo.board_real_file}</p>
                    <button className="btn-cancel" style={{border:"none"}} onClick={e=>onDeleteAttachFileHandler(e)}><img src={cancelIcon} alt="" /></button>
                  </div>
                }
              </div>
            }
            <div className="form-contoller bt-btn">
              <Link to={'/Branch/NoticeSet'} className="form-contoller-btn btn-no" style={Number(board_idx)===0?{width:"48%"}:varNoticeInfo.board_bh_idx!==branch_idx?{width:"100%"}:{}}>목록</Link>
              <button className={Number(board_idx)===0||varNoticeInfo.board_bh_idx!==branch_idx?"form-contoller-btn btn-yes hide-only":"form-contoller-btn btn-yes show-only"} style={{margin:"0px 5px"}} onClick={e=>onEditNoticeHandler(e)}>수정</button>
              <button className={Number(board_idx)===0||varNoticeInfo.board_bh_idx!==branch_idx?"form-contoller-btn btn-del hide-only":"form-contoller-btn btn-yes show-only"} onClick={e=>onDeleteNoticeHandler(e)}>삭제</button>
              <button className={Number(board_idx)===0?"form-contoller-btn btn-yes":"form-contoller-btn btn-yes hide-only"} onClick={e=>onUpdateNoticeHandler(e)} style={{marginRight:"0"}}>저장</button>
            </div>
          </div>
        </div>	
      </div>
    </div>	
  );
}
export default NoticeDetail;